import MobileStatusFlow from "./MobileStatusFlow";

export default function MobilePartnerStatusView() {
  return (
    <div className="flex flex-col">
      <MobileStatusFlow
        flowKey="hub"
        title="Entrega por parceiros"
      />
    </div>
  );
}
